module.exports = __webpack_public_path__ + "static/media/objectDefault.3e813c3d.png";